module.exports = __webpack_public_path__ + "static/media/101-share.91f779ba.svg";